import { Box, Typography } from "@mui/material"



import GestaoVagaHorariosIngresso from "./GestaoVagaHorariosIngresso.jsx"



/**

 * Exibe blocos da mensagem configurada no painel (md_g_vagas_mensagem_app).

 */

function horariosLinhasSomenteLeitura(vaga, msg) {
	if (Array.isArray(msg?.horariosLinhas) && msg.horariosLinhas.length > 0) {
		return msg.horariosLinhas
	}
	const labels = vaga?.configuracao?.labels ?? {}
	const lblMin = labels.minimo || "Piso mínimo"
	const lblExp = labels.expectativa || "Expectativa de ganho"
	return (Array.isArray(vaga?.horarios) ? vaga.horarios : []).map((h) => {
		const partes = []
		if (h.horaInicio && h.horaFim) {
			partes.push(`${h.horaInicio} – ${h.horaFim}`)
		}
		if (h.valorMinimo) {
			partes.push(`${lblMin}: ${h.valorMinimo}`)
		}
		if (h.expectativaGanho) {
			partes.push(`${lblExp}: ${h.expectativaGanho}`)
		}
		return {
			diaSemana: h.diaSemana,
			diaId: h.diaId,
			diaNome: h.diaNome,
			diaAbrev: h.diaAbrev,
			texto: partes.length > 0 ? partes.join(" · ") : "—",
		}
	})
}

export default function GestaoVagaMensagem({

	vaga,

	dados = null,

	onIngressoAtualizado = null,

	somenteLeitura = false,

	destaqueIngressoHoje = null,

	rotulos,

}) {

	const msg = vaga?.mensagem ?? {}

	const cfg = vaga?.configuracao?.labels ?? {}

	const horariosLinhas = somenteLeitura
		? horariosLinhasSomenteLeitura(vaga, msg)
		: msg.horariosLinhas ?? []

	const exibirIngresso =
		!somenteLeitura && Boolean(dados && vaga?.id && vaga?.ingresso)

	const valorGeral = String(vaga?.valorPreferencia || "").trim()



	if (!vaga) return null



	const temAlgo =

		msg.titulo ||

		msg.descricao ||

		msg.cidadeEstado ||

		msg.qtdTitulares ||

		valorGeral ||

		horariosLinhas.length > 0



	if (!temAlgo) {

		return (

			<Typography variant="body2" color="text.secondary">

				Nenhuma informação configurada para exibir nesta vaga.

			</Typography>

		)

	}



	return (

		<Box className="flex flex-col gap-3">

			{msg.titulo ? (

				<Typography variant="h6" component="h2" className="font-semibold">

					{msg.titulo}

				</Typography>

			) : null}

			{msg.descricao ? (

				<Typography variant="body1" className="whitespace-pre-wrap">

					{msg.descricao}

				</Typography>

			) : null}

			{msg.qtdTitulares ? (

				<Box>

					<Typography variant="caption" color="text.secondary" display="block">

						Titulares (meta diária)

					</Typography>

					<Typography variant="body2">

						{msg.qtdTitulares} {msg.qtdTitulares === 1 ? "pessoa" : "pessoas"}

					</Typography>

				</Box>

			) : null}

			{valorGeral ? (

				<Box>

					<Typography variant="caption" color="text.secondary" display="block">

						{cfg.expectativa || "Expectativa de ganho"}

					</Typography>

					<Typography variant="body2" className="font-medium">

						{valorGeral}

					</Typography>

				</Box>

			) : null}

			{horariosLinhas.length > 0 ? (

				<Box>

					<Typography variant="caption" color="text.secondary" display="block" className="mb-1">

						Horários e valores

					</Typography>

					{exibirIngresso ? (

						<GestaoVagaHorariosIngresso

							dados={dados}

							idVaga={vaga.id}

							ingresso={vaga.ingresso}

							horariosLinhas={horariosLinhas}

							tituloVaga={vaga.titulo || msg.titulo || "esta vaga"}

							destaqueIngressoHoje={destaqueIngressoHoje}

							rotulos={rotulos}

							onIngressoAtualizado={(novoIngresso, payload) => {
								const dias = novoIngresso?.dias ?? payload?.ingresso?.dias ?? []
								const porDiaId = Object.fromEntries(
									dias.map((d) => [d.diaId, d])
								)
								onIngressoAtualizado?.({
									...vaga,
									ingresso: novoIngresso ?? payload?.ingresso,
									mensagem: {
										...msg,
										horariosLinhas: horariosLinhas.map((linha) => ({
											...linha,
											slotIngresso:
												porDiaId[linha.diaId] ??
												linha.slotIngresso ??
												null,
										})),
									},
								})
							}}

						/>

					) : (

						horariosLinhas.map((linha) => (

							<Box key={`${linha.diaSemana}-${linha.texto}`} className="mb-2">

								<Typography variant="subtitle2" className="font-medium">

									{linha.diaAbrev || linha.diaNome}

								</Typography>

								<Typography variant="body2" color="text.secondary">

									{linha.texto}

								</Typography>

							</Box>

						))

					)}

					{(cfg.minimo || cfg.expectativa) && (

						<Typography variant="caption" color="text.disabled" className="mt-1 block">

							{cfg.minimo && cfg.expectativa

								? `Rótulos: ${cfg.minimo} · ${cfg.expectativa}`

								: null}

						</Typography>

					)}

				</Box>

			) : null}

		</Box>

	)

}


